// extracted by mini-css-extract-plugin
export default {"newsList":"index_newsList_02qSP","by":"index_by_cwOw4","date":"index_date_dut5p","pl":"index_pl_cVf1q","l_on":"index_l_on_ihDUx","xx":"index_xx_h25nK clearfix"};